// Polyfills
import 'Utils/_closest.polyfill.js'
import 'Utils/_matches.polyfill.js'
import 'Utils/_nodelist.polyfill.js'
import 'Utils/_arrayFrom.polyfill.js'
import 'Utils/_promise.polyfill.js'
import 'Utils/_includes.polyfill.js'
import 'Utils/_objectFit.polyfill.js'
import 'Utils/_urlSearchParams.polyfill.js'
import 'Utils/_isNan.polyfill.js'
import 'Utils/_customEvent.polyfill.js'
import 'Utils/_requestAnimFrame.polyfill.js'

import 'Utils/objectFitFix.js'
// Misc
// Use log() instead of console.log()
// const log = console.log.bind(console);

// Import Module JS
import 'Modules/a-quote-slider/a-quote-slider.js'
import 'Modules/a-stage/a-stage.js'
import 'Modules/a-teaser-slider-two-column/a-teaser-slider-two-column.js'
import 'Modules/a-portfolio-slider/a-portfolio-slider.js'
import 'Modules/a-slider-ways-of-working/a-slider-ways-of-working.js'
import 'Modules/n-main-navigation/n-main-navigation.js'
import 'Modules/g-teaser-portfolio/g-teaser-portfolio.js'
import 'Modules/a-grid-three-columns/a-grid-three-columns.js'
import 'Modules/a-accordion-two-column/a-accordion-two-column.js'
import 'Modules/a-team-grid/a-team-grid.js'
import 'Modules/a-portfolio-grid/a-portfolio-grid.js'
import 'Modules/c-cookies/c-cookies.js'
import 'Modules/s-404-stage/s-404-stage.js'

// Components
// import collapse from 'Components/collapse.js'
import smoothScroll from 'Components/smooth-scroll'
import scrollAcceleration from 'Components/scroll-acceleration'
import wow from 'Components/wow'
import mobileTabletCheck from 'Components/check-mobile'

// Modulübersichtsspezifische Scripts
import 'Modules/_modulstaging/moduluebersicht.js'
document.addEventListener('DOMContentLoaded', () => {
  smoothScroll()
  scrollAcceleration()
  wow()
  mobileTabletCheck()
})
